export const payCycleLoading = (state) => ({
  ...state,
  loading: true,
});

export const payCycle = (state, { payload }) => ({
  ...state,
  loading: false,
  ...payload,
});

export const payCycleFailed = (state, { payload }) => ({
  ...state,
  loading: false,
  fetchError: payload,
});
